class ImportacaoCodigosFornecedoresModal {

    static get $inject() {
        return ['gql', '$scope', 'Produtos']
    }

    constructor(gql, $scope, Produtos) {
        this.gql = gql
        this.apply = fun => $scope.$apply(fun)
        this.Produtos = Produtos
    }

    onFileSelect() {
        if (this.arquivo) {
            const parts = this.arquivo.name.toUpperCase().split('.')
            this.formato = parts[parts.length - 1]
        }
    }

    submit() {
        if (this.form.$valid) {
            this.promise = this.Produtos
                .importCodigosFornecedores(this.resolve.empresaId, this.resolve.filialId, this.arquivo, this.formato)
                .then(() => this.close())
                .catch(console.error)
        }
    }
}

angular.module("eficienciaFiscalModule")
    .component("importacaoCodigosFornecedoresModal", {
        controller: ImportacaoCodigosFornecedoresModal,
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
        <form name="$ctrl.form" ng-submit="$ctrl.submit()" novalidate>
            <promise-tracker promise="$ctrl.promise" active="isLoading">
                <modal modal-title="Importação de códigos de fornecedores" close="$ctrl.close">
                    <modal-body>
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label>Arquivo XLSX, CSV ou JSON</label>
                                <input 
                                    class="btn btn-default btn-block" 
                                    type="file" 
                                    name="arquivo" 
                                    accept=".xlsx,.csv,.json"
                                    ngf-select 
                                    ng-model="$ctrl.arquivo" 
                                    ng-change="$ctrl.onFileSelect()"
                                    required>
                                <div ng-messages="$ctrl.form.arquivo.$error" ng-if="$ctrl.form.$submitted">
                                    <span class='help-block txt-color-red font-xs no-margin' ng-message="required">
                                        Selecione um arquivo no formato XLSX, CSV ou JSON.
                                    </span>
                                </div>
                            </div>
                            <div class="col-xs-12" ng-hide="$ctrl.arquivo"> 
                                Arquivos de exemplo: 
                                <a href="/assets/files/exemplo_codigos_fornecedores.xlsx" target="_blank">XLSX</a>, 
                                <a href="/assets/files/exemplo_codigos_fornecedores.csv" target="_blank">CSV</a> ou 
                                <a href="/assets/files/exemplo_codigos_fornecedores.json" download="exemplo_codigos_fornecedores.json" target="_blank">JSON</a>
                            </div>
                            <div class="col-xs-12 form-group repeat-animation" ng-if="$ctrl.arquivo">
                                <label>Formato</label>
                                <div class="smart-form">
                                    <div class="inline-group">
                                        <label class="radio no-break">
                                            <input type="radio" ng-model="$ctrl.formato" name="formato" value="XLSX" required>
                                            <i></i> XLSX
                                        </label>
                                        <label class="radio no-break">
                                            <input type="radio" ng-model="$ctrl.formato" name="formato" value="CSV" required>
                                            <i></i> CSV
                                        </label>
                                        <label class="radio no-break">
                                            <input type="radio" ng-model="$ctrl.formato" name="formato" value="JSON" required>
                                            <i></i> JSON
                                        </label>
                                    </div>
                                </div>
                                <div ng-messages="$ctrl.form.formato.$error" ng-if="$ctrl.form.$submitted">
                                    <span class='help-block txt-color-red font-xs no-margin' ng-message="required">
                                        Selecione um formato do arquivo
                                    </span>
                                </div>
                            </div>
                        </div>
                    </modal-body>
                    <modal-footer>
                        <button class="btn btn-primary" ng-disabled="isLoading">
                            <span ng-hide="isLoading">Enviar</span>
                            <span ng-show="isLoading">Enviando...</span>
                        </button>
                        <button 
                            class="btn btn-default"
                            type="button"
                            ng-click="$ctrl.close()"
                            ng-disabled="isLoading">
                            Fechar
                        </button>
                    </modal-footer>
                </modal>
            </promise-tracker>
        </form>
        `
    })
